import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { RovoIcon } from "./icons/rovo-icon";
import { LoadingDotsAnimation } from "./loading-dots-animation";

type AISummaryLoadingAnimationProps = {
    traceResponse?: string;
};
export const AISummaryLoadingAnimation = ({
    traceResponse
}: AISummaryLoadingAnimationProps) => {
    return (
        <div css={aiSummaryLoadingAnimationWrapperStyle}>
            <RovoIcon css={css({ marginInlineEnd: "8px" })} />
            <span css={css({ lineHeight: "20px" })}>{traceResponse}</span>
            <LoadingDotsAnimation />
        </div>
    );
};

const aiSummaryLoadingAnimationWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    fontSize: "14px",
    color: token("color.text")
});
